import { useState, useEffect, forwardRef } from "react";
import { FOLLOW_STATUS } from "../utils/constants";
import moment from 'moment';
import { LazyLoadImage } from "react-lazy-load-image-component";
import BlueTick from '../images/blue-tick.png';
import CrossPink from '../images/cross.png';
import axios from "axios";
import useDidMountEffect from "../utils/useDidMountEffect";
import { useToasts } from 'react-toast-notifications';
import currency from "currency.js";

// MUI - START
import { styled } from '@mui/material/styles';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.body}`]: {
        fontSize: '12px',
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));
// MUI - END

const FollowerRow = forwardRef(({ row, setBlockUpdate }, ref) => {
    const { addToast } = useToasts();
    const [block, setBlock] = useState(!!row.mute_id);
    const [subscriptionDate, setSubscriptionDate] = useState('');

    const handleMute = () => {
        axios.patch(`/api/followers/${row.id}`, {
            block: block
        })
            .then(response => {
                setBlockUpdate(row.id);
                addToast('Follower status updated', { appearance: 'success', autoDismiss: true });

                console.log({ response });
            })
            .catch(error => {
                addToast('Unable to process request', { appearance: 'error', autoDismiss: true });
                console.log({ error });
            });
    };

    useDidMountEffect(() => {
        handleMute();
    }, [block]);

    useEffect(() => {
        if (row.status == FOLLOW_STATUS.UNFOLLOWED_DOES_NOT_RENEW) {
            const expdate = moment.utc(row.expdate).local();

            if (expdate.isValid()) {
                setSubscriptionDate(expdate.format('D MMM YYYY'));
            } else {
                setSubscriptionDate('');
            }
        }
    }, []);

    return <StyledTableRow ref={ref}>
        <StyledTableCell>
            {
                <a href={`${process.env.MIX_APP_URL}/${row.login}`} title={row.login}>
                    @{row.login}
                </a>
            }
            {
                <div className="foll-usr">
                    {row.firstname} {row.lastname}
                </div>
            }
        </StyledTableCell>

        <StyledTableCell className="right-align">
            {currency(row.total_earnings).format()}
        </StyledTableCell>

        <StyledTableCell className="right-align">
            {currency(row.tip_ppv_earnings).format()}
        </StyledTableCell>

        <StyledTableCell className="sub-status-ico-lbl px-0">
            {
                (row.status == FOLLOW_STATUS.ACTIVE || row.status == FOLLOW_STATUS.PAUSED) && <LazyLoadImage
                    src={BlueTick}
                    alt="Active"
                    width={14}
                    style={{ width: '14px' }}
                />
            }
            {
                row.status == FOLLOW_STATUS.UNFOLLOWED_DOES_NOT_RENEW ? subscriptionDate : ''
            }
            {
                row.status == FOLLOW_STATUS.UNSUBSCRIBED && <LazyLoadImage
                    src={CrossPink}
                    alt="Expired"
                    width={14}
                    style={{ width: '14px' }}
                />
            }
        </StyledTableCell>

        <StyledTableCell className="center-align">
            {row.likes_count}
        </StyledTableCell>

        <StyledTableCell style={{ maxWidth: 172, minWidth: 120 }} className="td-unfollow-reason-col">
            {(row.status == FOLLOW_STATUS.UNSUBSCRIBED || row.status == FOLLOW_STATUS.UNFOLLOWED_DOES_NOT_RENEW)
                ? row.unfollow_reason || 'No reason provided'
                : ''
            }
        </StyledTableCell>

        <StyledTableCell>
            <label className="switch">
                <input
                    type="checkbox"
                    className="checkbox-followmute"
                    name="new_subscriber"
                    id="new_subscriber"
                    onChange={() => setBlock(!block)}
                    checked={block}
                />
                <span className="slider round"></span>
            </label>
        </StyledTableCell>
    </StyledTableRow>;
});

export default FollowerRow;
